import { useState } from "react"
import { LuLoaderCircle } from "react-icons/lu"
import { FiImage, FiVideo, FiMusic, FiCpu } from "react-icons/fi"

import { useWebSocket } from "@/hooks/useWebSocket"
import { useModal } from "@/contexts/ModalContext"
import TaskModal from "../modals/TaskModal"


export default function TaskCard({ task, onResolved }) {
    const { openModal } = useModal()
    const [liveStatus, setLiveStatus] = useState(task.status)

    const user = task.user
    const userName = [user?.first_name, user?.last_name].filter(Boolean).join(' ') || user?.username || ''

    useWebSocket(['task_updated', 'task_completed', 'task_failed'], {
        onMessage: (message) => {
            if (message.data?.taskId !== task._id) return
            const update = message.data
            if (update.status) setLiveStatus(update.status)
            if (['completed', 'failed', 'cancelled'].includes(update.state)) {
                onResolved?.()
            }
        },
    })

    return (
        <div className='flex flex-col gap-1 relative group'>
            <div
                className='flex px-2 flex-col items-center justify-center h-full relative aspect-video bg-card rounded-md overflow-hidden border border-secondary/60 cursor-pointer hover:bg-secondary/60'
                onClick={() => openModal(<TaskModal task={task} />, 'side')}
            >
                <div className='task-gradient-bg absolute top-0 left-0 w-full h-full' aria-hidden='true'>
                    <div className='task-gradient-blob task-gradient-blob--a' />
                    <div className='task-gradient-blob task-gradient-blob--b' />
                    <div className='task-gradient-blob task-gradient-blob--c' />
                </div>
                <div className='flex text-center items-center text-[10px] bg-background/80 text-secondary-foreground rounded-sm px-1 py-0.5 z-10'>
                    {liveStatus}
                </div>
            </div>
            <div className='flex flex-col items-start px-1'>
                <span className='text-[10px] text-secondary-foreground/50 truncate max-w-full'>
                    {user?.email}
                </span>
                <span className='text-xs text-secondary-foreground truncate max-w-full truncate'>{task.request_body?.payload?.prompt}</span>
            </div>
        </div>
    )
}
